import axios from 'axios'
import {
    SUBMIT_TAT_ANALYSIS_REQUEST,
    SUBMIT_TAT_ANALYSIS_SUCCESS,
    SUBMIT_TAT_ANALYSIS_FAIL,
    SUBMIT_TAT_ANALYSIS_RESET,
    GET_MY_TAT_ANALYSIS_REQUEST,
    GET_MY_TAT_ANALYSIS_SUCCESS,
    GET_MY_TAT_ANALYSIS_FAIL,
    GET_MY_TAT_ANALYSIS_RESET,
    GET_TAT_STATISTICS_REQUEST,
    GET_TAT_STATISTICS_SUCCESS,
    GET_TAT_STATISTICS_FAIL,
    GET_TAT_STATISTICS_RESET,
    UPDATE_TAT_ANALYSIS_REQUEST,
    UPDATE_TAT_ANALYSIS_SUCCESS,
    UPDATE_TAT_ANALYSIS_FAIL,
    UPDATE_TAT_ANALYSIS_RESET,
    DELETE_TAT_ANALYSIS_REQUEST,
    DELETE_TAT_ANALYSIS_SUCCESS,
    DELETE_TAT_ANALYSIS_FAIL,
    DELETE_TAT_ANALYSIS_RESET,
    GET_TAT_ANALYSIS_REPORT_REQUEST,
    GET_TAT_ANALYSIS_REPORT_SUCCESS,
    GET_TAT_ANALYSIS_REPORT_FAIL,

} from '../constants/tatAnalysisConstant';
import { logout } from './userActions';

const baseUrl = process.env.REACT_APP_API_URL;

export const submitTatAnalysis = (tatAnalysisData) => async (dispatch, getState) => {
    try {
        dispatch({
            type: SUBMIT_TAT_ANALYSIS_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.post(
            `${baseUrl}/tatAnalysis/submit`,
            tatAnalysisData,
            config
        );

        dispatch({
            type: SUBMIT_TAT_ANALYSIS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: SUBMIT_TAT_ANALYSIS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getMyTatAnalysis = (queryParams) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GET_MY_TAT_ANALYSIS_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.get(
            `${baseUrl}/tatAnalysis/my-tat-analysis${queryParams ? `?${queryParams}` : ''}`,
            config
        );

        dispatch({
            type: GET_MY_TAT_ANALYSIS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: GET_MY_TAT_ANALYSIS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getTatStatistics = (queryParams) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GET_TAT_STATISTICS_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.get(
            `${baseUrl}/tatAnalysis/tat-statistics${queryParams ? `?${queryParams}` : ''}`,
            config
        );

        dispatch({
            type: GET_TAT_STATISTICS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: GET_TAT_STATISTICS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const updateTatAnalysis = (id, tatData) => async (dispatch, getState) => {
    try {
        dispatch({ type: UPDATE_TAT_ANALYSIS_REQUEST });

        const { userLogin: { userInfo } } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.put(
            `${baseUrl}/tatAnalysis/update/${id}`, // Change this line to match your other actions
            tatData,
            config
        );

        dispatch({
            type: UPDATE_TAT_ANALYSIS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        dispatch({
            type: UPDATE_TAT_ANALYSIS_FAIL,
            payload: error.response?.data?.message || error.message,
        });
    }
};

export const deleteTatAnalysis = (id) => async (dispatch, getState) => {
    try {
        dispatch({
            type: DELETE_TAT_ANALYSIS_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.delete(
            `${baseUrl}/tatAnalysis/delete/${id}`,
            config
        );

        dispatch({
            type: DELETE_TAT_ANALYSIS_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: DELETE_TAT_ANALYSIS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getTatAnalysisReport = (queryParams) => async (dispatch, getState) => {
    try {
        dispatch({
            type: GET_TAT_ANALYSIS_REPORT_REQUEST,
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const { data } = await axios.get(
            `${baseUrl}/tatAnalysis/report${queryParams ? `?${queryParams}` : ''}`,
            config
        );

        dispatch({
            type: GET_TAT_ANALYSIS_REPORT_SUCCESS,
            payload: data,
        });
    } catch (error) {
        if (error.response?.status === 401) {
            dispatch(logout());
            return;
        }
        dispatch({
            type: GET_TAT_ANALYSIS_REPORT_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};